<template>
  <vx-card class="org-card w-full lg:w-2/3 xl:w-2/3">
    <div class="p-4">
      <div class="vx-row">
        <div
          class="vx-col w-full mb-base lg:w-1/3 xl:w-1/3 items-center"
          style="position: relative"
        >
          <vs-avatar
            v-if="logoInput"
            class="my-4 profile-picture"
            size="160px"
            :src="logoInput"
          />
          <vs-avatar
            v-else-if="localData.logo"
            class="my-4 profile-picture"
            size="160px"
            :src="constants.s3Bucket + '/organization/logo/' + localData.logo"
          />
          <vs-avatar
            v-else
            class="my-4 profile-picture"
            size="160px"
            :src="
              require('@/assets/images/icons/organization/business_black_36dp.svg')
            "
          />
          <vs-button
            radius
            color="no-color"
            type="relief"
            icon="photo_camera"
            class="upload-btn vs-con-loading__container"
            @click="$refs.update_avatar_input.click()"
            ref="loadableButton"
            id="upload-organization-logo"
            :title="$t('orgDashboard.createOrganization.logo.uploadButton')"
          ></vs-button>
          <vs-prompt
            :title="$t('orgDashboard.createOrganization.logo.adjustTitle')"
            :accept-text="$t('orgDashboard.createOrganization.logo.save')"
            @cancel="closeEditLogoPrompt"
            @accept="cropAndUploadLogo"
            @close="closeEditLogoPrompt"
            :active.sync="editLogoPrompt"
          >
            <div class="con-exemple-prompt">
              <clipper-basic :src="tempLogo" ref="clipper"></clipper-basic>
            </div>
          </vs-prompt>
          <input
            type="file"
            class="hidden"
            name="Profile Picture"
            ref="update_avatar_input"
            @change="openEditLogoPrompt"
            accept="image/*"
          />
        </div>
        <div class="vx-col w-full lg:w-2/3 xl:w-2/3">
          <vs-row class="mb-base">
            <label>{{ $t('orgDashboard.createOrganization.organizationName') }}</label>
            <vs-input class="w-full" v-model="localData.name" />
          </vs-row>
          <vs-row class="mb-base">
            <label>{{ $t('orgDashboard.createOrganization.organizationUsername') }}</label>
            <vs-input
              class="w-full"
              v-model="localData.slug"
              @input="checkSlug()"
            />
            <span v-if="localData.slug">
              <small v-if="usernameError" class="text-danger">{{
                usernameError
              }}</small>
              <small v-else-if="usernameAvailable" class="text-success">{{
                usernameAvailable
              }}</small>
            </span>
          </vs-row>
          <vs-row class="mb-base">
            <label>{{ $t('orgDashboard.createOrganization.website') }}</label>
            <vs-input class="w-full" v-model="localData.website" />
          </vs-row>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full lg:w-1/2 xl:w-1/2 items-center">
          <vs-row class="mb-base">
            <label>{{ $t('orgDashboard.createOrganization.workEmail') }}</label>
            <vs-input class="w-full" v-model="localData.workEmail" />
          </vs-row>
          <vs-row class="mb-base">
            <label>{{ $t('orgDashboard.createOrganization.location') }}</label>
            <vs-input class="w-full" v-model="localData.location" />
          </vs-row>
        </div>
        <div class="vx-col w-full lg:w-1/2 xl:w-1/2">
          <vs-row class="mb-base">
            <label>{{ $t('orgDashboard.createOrganization.organizationType') }}</label>
            <!-- <vs-input class="w-full" v-model="localData.organizationType" /> -->
            <v-select
              class="organization-type-input w-full"
              :options="organizationTypeOptions"
              v-model="localData.organizationType"
            />
          </vs-row>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full lg:w-1/2 xl:w-1/2">
          <label>{{ $t('orgDashboard.createOrganization.primaryThemeColor') }}</label>
          <vs-row class="color-settings mt-3 mb-base">
            <div
              v-for="(cs, index) in colorSet"
              :key="index"
              class="colorset-item items-center"
              @click.stop="setPrimaryThemeColor(cs)"
              :style="{ backgroundColor: cs }"
            >
              <feather-icon
                v-if="localData.primaryThemeColor === cs"
                class="primarycolor-check-icon"
                icon="CheckCircleIcon"
                svgClasses="text-white w-5 h-5"
              />
            </div>
          </vs-row>
        </div>
        <div class="vx-col w-full lg:w-1/2 xl:w-1/2">
          <vs-row class="mb-base">
            <label>{{ $t('orgDashboard.createOrganization.secondaryThemeColor') }}</label>
            <vx-input-group class="w-full mt-3">
              <template slot="prepend">
                <div class="prepend-text bg-primary">
                  <span>#</span>
                </div>
              </template>

              <vs-input
                class="w-full"
                v-model="localData.secondaryThemeColor"
              />
            </vx-input-group>
          </vs-row>
        </div>
      </div>

      <!-- <div class="mb-base mt-3">
        <div class="vx-col w-full">
          <div class="mb-2">
            <label>Select your organization culture?</label>
          </div>
          <div class="vx-row mt-3">
            <div class="vx-col w-full lg:w-1/3 xl:w-1/3">
              <div class="organization-culture p-3 mb-5">Normative Culture</div>
            </div>
            <div class="vx-col w-full lg:w-1/3 xl:w-1/3">
              <div class="organization-culture p-3 mb-5">
                Baseball Team Culture
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/3 xl:w-1/3">
              <div class="organization-culture p-3 mb-5">Tough Guy Culture</div>
            </div>
            <div class="vx-col w-full lg:w-1/3 xl:w-1/3">
              <div class="organization-culture p-3 mb-5">Academic Culture</div>
            </div>
            <div class="vx-col w-full lg:w-1/3 xl:w-1/3">
              <div class="organization-culture p-3 mb-5">Pragmatic Culture</div>
            </div>
            <div class="vx-col w-full lg:w-1/3 xl:w-1/3">
              <div class="organization-culture p-3 mb-5">Process Culture</div>
            </div>
            <div class="vx-col w-full lg:w-1/3 xl:w-1/3">
              <div class="organization-culture p-3 mb-5">Club Culture</div>
            </div>
            <div class="vx-col w-full lg:w-1/3 xl:w-1/3">
              <div class="organization-culture p-3 mb-5">Fortress Culture</div>
            </div>
            <div class="vx-col w-full lg:w-1/3 xl:w-1/3">
              <div class="organization-culture p-3 mb-5">
                Bet It All Culture
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <div class="vx-row mb-base">
        <div class="vx-col w-full">
          <vs-row>
            <label>{{ $t('orgDashboard.createOrganization.about') }}</label>
            <vs-textarea
              class="w-full"
              counter="200"
              :counter-danger.sync="counterDanger"
              maxlength="200"
              v-model="localData.about"
            />
          </vs-row>
        </div>
      </div>

      <!-- Save & Reset Button -->
      <div class="flex flex-wrap items-center justify-end">
        <vs-button
          color="#44CC88"
          class="ml-auto mt-2"
          :disabled="!localData.name || !localData.slug"
          @click.stop="saveOrganizationProfile()"
          >{{ $t('orgDashboard.createOrganization.saveChanges') }}</vs-button
        >
      </div>
    </div>
  </vx-card>
</template>

<script>
import {
  successNotifyService,
  failureNotifyService,
} from "@/services/errors.service.js";
import constants from "@/constants.js";
import vSelect from "vue-select";
import orgDefaultConfig from "@/assets/data/org-default-config.js"

export default {
  data() {
    return {
      counterDanger: false,
      localData: {},
      colorSet: [
        "#3BA0BE",
        "#6859B4",
        "#008000",
        "#B3B3B3",
        "#C6211B",
        "#E4D033",
        "#EA7526",
        "#F36677",
      ],
      constants,
      logoInput: null,
      editLogoPrompt: false,
      tempLogo: null,
      initialImgInput: null,
      newLogoUrl: null,
      organizationTypeOptions: [],
      usernameError: false,
      usernameAvailable: false,
    };
  },
  components: {
    vSelect,
  },
  computed: {
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    userData() {
      return this.$store.state.users.data;
    },
    userId() {
      return this.$store.state.auth.user._id;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    organizationTypeOptions() {
      return [
        this.$t('orgDashboard.createOrganization.organizationTypeOptions.business'),
        this.$t('orgDashboard.createOrganization.organizationTypeOptions.academic'),
        this.$t('orgDashboard.createOrganization.organizationTypeOptions.recruiter')
      ];
    },
  },
  watch: {
    /*orgData(newVal) {
      if (newVal) {
        if (newVal._id) {
          window.location.href = "/organization/dashboard";
        }
      }
    },*/
  },
  methods: {
    updateOrganizationLogo(input) {
      const payload = {
        imgInput: input,
        _id: this.userId,
        maxSize: 1, // In MB
      };

      const _id = payload._id;

      const logoData = input.target.result;
      const logoUrl = _id + "-" + this.initialImgInput.target.files[0].name;

      const olObj = {
        logoData,
        logoUrl,
      };

      this.logoInput = logoData;

      this.localData.olObj = olObj;
      this.localData.logo = logoUrl;
    },
    setPrimaryThemeColor(cs) {
      this.localData["primaryThemeColor"] = cs;
      // console.log(this.localData.primaryThemeColor === cs);
      this.$forceUpdate();
    },
    saveOrganizationProfile() {
      this.$vs.loading();

      const payload = {
        userId: this.userId,
        name: this.localData.name,
        slug:this.localData.slug,
        website: this.localData.website,
        logo: this.localData.logo,
        olObj: this.localData.olObj,
        workEmail: this.localData.workEmail,
        organizationType: this.localData.organizationType,
        location: this.localData.location,
        primaryThemeColor: this.localData.primaryThemeColor,
        secondaryThemeColor: this.localData.secondaryThemeColor,
        organizationCulture: this.localData.organizationCulture,
        about: this.localData.about,
      };

      this.$store
        .dispatch("organization/createOrganization", payload)
        .then((res) => {
          this.$store
          .dispatch("organization/setDefaultOrganizationConfig",orgDefaultConfig(res.data._id))
          .then(res=>{
            this.$vs.loading.close();
            window.location.href = `/organization/${res.data.slug}/dashboard`;
          })
          .catch(err=>{
            window.location.href = `/organization/${res.data.slug}/dashboard`;
            throw err;
          })
        })
        .catch((err) => {
          throw err;
        });
    },
    checkSlug() {
      this.$store
        .dispatch("organization/checkSlug", this.localData.slug)
        .then((res) => {
          if (res.total > 0) {
            this.usernameError = this.$t('orgDashboard.createOrganization.usernameExists');
          } else {
            this.usernameError = false;
            this.usernameAvailable = this.$t('orgDashboard.createOrganization.usernameAvailable');
          }
        })
        .catch((err) => {});
    },
    closeEditLogoPrompt() {
      this.$forceUpdate();
    },
    logoValidations(imgInput, maxSize) {
      if (imgInput.target.files && imgInput.target.files[0]) {
        let currentThis = this;

        if (imgInput.target.files > 1) {
          return;
        }
        const parts = imgInput.target.files[0].name.split(".");
        const ext = parts[parts.length - 1];

        //////////////////////////////////////////
        // Check for correct image file type
        //////////////////////////////////////////

        if (ext !== "jpg" && ext !== "jpeg" && ext !== "png") {
          const payload = {
            title: this.$t('orgDashboard.createOrganization.logo.incorrectFileType'),
            text: this.$t('orgDashboard.createOrganization.logo.incorrectFileTypeText'),
            currentThis,
          };

          failureNotifyService(payload);

          return;
        }

        //////////////////////////////////////////
        // Check for image file size
        //////////////////////////////////////////

        if (imgInput.target.files[0].size / (1024 * 1024) > maxSize) {
          const payload = {
            title: this.$t('orgDashboard.createOrganization.logo.fileSizeExceeded'),
            text: this.$t('orgDashboard.createOrganization.logo.fileSizeExceededText'),
            currentThis,
          };

          failureNotifyService(payload);

          return;
        }

        return true;
      }
    },
    openEditLogoPrompt(input) {
      // Profile Picture Validation
      if (!this.logoValidations(input, 1)) return; // 1 MB

      this.initialImgInput = input;

      const reader = new FileReader();
      reader.onload = (e) => {
        this.tempLogo = e.target.result;
        this.editLogoPrompt = true;
      };
      reader.readAsDataURL(input.target.files[0]);
    },
    cropAndUploadLogo() {
      const currentThis = this;
      const canvas = this.$refs.clipper.clip();
      canvas.toBlob(function (blob) {
        const reader = new FileReader();
        reader.onload = (e) => {
          // // console.log(e.target.result);
          currentThis.updateOrganizationLogo(e);
        };
        reader.readAsDataURL(blob);
      });
    },
  },
  created() {
    /*if (this.orgData && this.orgData._id) {
      window.location.href = `${this.orgData._id}/organization/dashboard`;
    }*/
  },
};
</script>

<style scoped>
.organization-culture {
  border: 1px solid #ebedf0;
  box-sizing: border-box;
  border-radius: 8px;
  cursor: pointer;

  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #414040;
}

.organization-culture:hover {
  background: #5585ff;
  color: white;
}

.organization-culture .selected {
  background: #5585ff;
  border-radius: 8px;
}

.vs-con-textarea {
  background: #fbfbfc;
  border: 1px solid #ebedf0 !important;
  box-sizing: border-box;
  border-radius: 6px;
  /*height: 109px;*/

  font-weight: normal;
  font-size: 1rem; /*16px*/
  line-height: 19px;
  letter-spacing: -0.02em;

  color: #888888;

  margin-bottom: 0;
}

.vs-con-textarea >>> .vs-textarea {
  background: #fbfbfc;
  /*border: 1px solid #EBEDF0!important;*/
  box-sizing: border-box;
  border-radius: 6px;
  height: 130px !important;

  font-weight: normal;
  font-size: 1rem; /*16px;*/
  line-height: 19px;
  letter-spacing: -0.02em;

  color: #888888;
}

.vs-button {
  border-radius: 6px;
}

.profile-picture {
  position: relative;
  width: 8rem;
  height: 8rem;
}

.upload-btn {
  position: absolute;
  margin: auto;
  background: rgba(255, 255, 255, 0.35) !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.color-settings div {
  border-radius: 6px;
  width: 9.5%;
  height: 40px;
  cursor: pointer;
  margin-right: 6px;
}

.color-settings .green {
  background: #008000;
}

.color-settings .blue {
  background: #3ba0be;
}

.color-settings .purple {
  background: #6859b4;
}

.color-settings .yellow {
  background: #e4d033;
}

.color-settings .orange {
  background: #ea7526;
}

.color-settings .red {
  background: #c6211b;
}

.color-settings .pink {
  background: #f36677;
}

.color-settings .gray {
  background: #b3b3b3;
}

.primarycolor-check-icon {
  top: calc(50% - 10px);
}

.vs--searchable >>> .vs__dropdown-toggle {
  color: #394066;
  background: #fbfbfc;
  border: 1px solid #ebedf0 !important;
  border-radius: 6px;
}
</style>
